import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '@/mocks/data';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-sm border-b border-background-200/70">
      <nav className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="text-xl font-heading font-bold text-foreground-900">挠脚心<span className="text-primary-500">vk</span></span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="切换菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileOpen(false)}
                className={`px-3 py-2.5 text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-primary-500 bg-primary-50 font-medium'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}